<template>
    <NavBar :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'">
        <template v-slot:title>
            <span class="nav-title">专辑</span>
        </template>
    </NavBar>
    <div class="album-box">
        <router-link :to="'/album/' + album.id" class="item" v-for="album in albums" :key="album.id">
            <img :src="album.cover" alt="" class="cover">
            <div class="info">
                <p class="title">{{ album.name }}</p>
                <div class="organization">
                    <img :src="album.organization.logo" alt="" class="logo">
                    <div>
                        <p class="subtitle">创作者</p>
                        <p class="name">{{ album.organization.name }}</p>
                    </div>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>